export default {
	appTitle: "base",
	login: "Login",
	register: "S'inscrire",
	home: "Accueil",
	service: "Service",
	starting: "Démarrage",
	records: "Dossiers",
	my: "Mon",
	start: "Démarrer",
	BonusRules: "Règles du Bonus",
	privacyPolicy: "Politique de confidentialité",
	wheels: "@:wheels:title",
	order: "@:router.starting",
	hotSongCharts: "@:home.hotMusicAlbum",
	hotMusic: "@:home.hotMusic",
	popular: "@:home.Popularhotels",
	gifts: "@:gifts.title",
	giftsRecord: "@:gifts.records.title",
	event: "@:home.service[1]",
	withdraw: "@:home.service[2]",
	deposit: "@:home.service[3]",
	tc: "@:home.service[4]",
	certificate: "@:home.service[5]",
	faqs: "@:home.service[6]",
	about: "@:home.service[7]",
	vip: "@:vip.title",
	transaction: "@:my.MyFinancial.menu[2]",
	profileItem: {
		title: "@:profileItem.title",
		profile: "@:my.MyDetail.menu[0]",
		updatePassword: "@:profileItem.menu[2]",
		updateTransactionPassword: "@:profileItem.menu[3]"
	},
	paymentMethods: "@:paymentMethods.title",
	notice: "@:my.Other.menu[1]",
	registrationAgreement: "@:system.terms",
	customerServices: "@:home.service[0]"
};
